// src/components/songEdit/fields/TuneFields.tsx
import React, { useState } from 'react';
import { Plus } from 'lucide-react';
import { TuneSearch } from '../search/TuneSearch';
import { RemovableBadge } from '../inputs/RemovableBadge';
import { Tune } from '../types/tuneTypes';

interface TuneFieldsProps {
  primaryTune?: string;
  alternateTunes?: Tune[];
  onPrimaryTuneChange: (tune: Tune | null) => void;
  onAlternateTuneAdd: (tune: Tune) => void;
  onAlternateTuneRemove: (index: number) => void;
}

export const TuneFields: React.FC<TuneFieldsProps> = ({
  primaryTune = '',
  alternateTunes = [],
  onPrimaryTuneChange,
  onAlternateTuneAdd,
  onAlternateTuneRemove,
}) => {
  const [alternateSearchValue, setAlternateSearchValue] = useState('');

  // Debug the alternate tunes data structure
  console.log('[TuneFields] alternateTunes received:', alternateTunes);
  console.log('[TuneFields] alternateTunes[0]:', alternateTunes[0]);

  // Show the first alternate tune in the input, or the search value if no tunes
  const displayValue = alternateTunes.length > 0 && alternateTunes[0]?.tune_name
    ? alternateTunes[0].tune_name
    : alternateSearchValue;

  const handleAlternateTuneSelect = (tune: Tune | null) => {
    console.log('[TuneFields] handleAlternateTuneSelect called with:', tune);
    if (tune) {
      // Check if this tune is already in the list
      const alreadyExists = alternateTunes.some(t => t?.tune_id === tune.tune_id);
      console.log('[TuneFields] Tune already exists?', alreadyExists);
      if (!alreadyExists) {
        console.log('[TuneFields] Calling onAlternateTuneAdd with:', tune);
        onAlternateTuneAdd(tune);
      } else {
        console.log('[TuneFields] Tune already in list, not adding');
      }
    } else {
      console.log('[TuneFields] No tune selected');
    }
  };

  return (
    <>
      <div className="song-form__group">
        <label className="song-form__label">Primary Tune</label>
        <TuneSearch
          value={primaryTune}
          onChange={onPrimaryTuneChange}
        />
      </div>

      <div className="song-form__group">
        <label className="song-form__label">Alternate Tunes</label>
        <TuneSearch
          value={displayValue}
          onChange={handleAlternateTuneSelect}
          placeholder="Search for alternate tune..."
        />
      </div>
    </>
  );
};